import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase";

/**
 * Uploads a file to Firebase Cloud Storage and returns the download URL.
 * 
 * @param {File} file - The file object to upload
 * @param {string} folder - The destination folder path in storage (e.g., 'images/gallery', 'videos')
 * @param {Function} onProgress - Optional callback function to track upload progress (returns progress percentage)
 * @returns {Promise<string>} - The public download URL of the uploaded file
 */
export const uploadToFirebase = async (file, folder = 'uploads', onProgress) => {
  if (!file) return null;

  // Create a unique filename to prevent overwrites
  const uniqueFileName = `${Date.now()}_${file.name.replace(/\s+/g, '_')}`;
  const storageRef = ref(storage, `${folder}/${uniqueFileName}`);

  // Start the upload
  const uploadTask = uploadBytesResumable(storageRef, file);

  return new Promise((resolve, reject) => {
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // Track progress
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        if (onProgress) {
          onProgress(progress);
        }
      },
      (error) => {
        console.error("Firebase upload error:", error);
        reject(error);
      },
      async () => {
        // Upload completed successfully, get the download URL
        try {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          resolve(downloadURL);
        } catch (error) {
          console.error("Error getting download URL:", error);
          reject(error);
        }
      }
    );
  });
};
